import React, { useCallback } from 'react'

import Image from 'next/image'
import { useRouter } from 'next/navigation'

import { CheckCircle } from '@phosphor-icons/react'
import { Button, Column, Row, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { EXPLORE_OUR_MEMBERSHIPS_POINT_ITEMS } from './constants'
import { Container } from './styles'

function EmajinSectionQuestions() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()
  const router = useRouter()

  const handleClick = useCallback(
    (link?: string) => {
      if (!link) return

      router.push(link)
    },
    [router],
  )

  const isNotDesktop = !isWideDesktop && !isDesktop

  return (
    <Container flexDirection={['column', 'column', 'row']}>
      {EXPLORE_OUR_MEMBERSHIPS_POINT_ITEMS.map(item => (
        <Column alignStart fullWidth key={item.id}>
          <Image alt={item.imageAlt} src={item.image} />

          <Text as="h4" bold important mb={6} mt={8} screen28>
            {item.title}
          </Text>

          <Text
            body
            mb={8}
            regular
            screen14={isNotDesktop}
            screen20={!isNotDesktop}
          >
            {item.plainText}
          </Text>

          <Column gap={8} mb={9}>
            {item.benefits.map(benefitItem => (
              <Row alignCenter gap={3} key={benefitItem.id}>
                <CheckCircle size={25} weight="fill" />

                <Text bold important screen18>
                  {benefitItem.text}
                </Text>
              </Row>
            ))}
          </Column>

          <Button large onClick={() => handleClick(item.link)}>
            {item.buttonCaption}
          </Button>
        </Column>
      ))}
    </Container>
  )
}

export default EmajinSectionQuestions
